/** Grymwyrd 日本語版の共有レイアウト（トップナビ＋フッター）のコピー。 */
export const layoutJa = {
  'layout.nav.veil': 'ヴェイル',
  'layout.nav.encyclopedia': '百科事典',
  'layout.nav.world': '世界',
  'layout.nav.play': 'プレイ',
  'layout.nav.books': 'ルール書&設定書',
  'layout.nav.community': 'コミュニティ',
  'layout.nav.homeAria': '{world}ホーム',
  'layout.nav.search': '百科事典を検索',
  'layout.nav.unmute': '環境音を再生',
  'layout.nav.mute': '環境音を停止',
  'layout.nav.coinBalance': 'コイン残高',
  'layout.nav.signedInAs': '{name}でサインイン中',
  'layout.nav.enter': '{world}へ進む',
  'layout.nav.toggleMenu': 'メニューを切り替え',
  'layout.nav.dashboard': 'マイ{world}（{name}）',
  'layout.nav.signOut': 'サインアウト',

  'layout.footer.hideLinks': 'サイトリンクを非表示',
  'layout.footer.showLinks': 'サイトリンク&法務',
  'layout.footer.tagline': '君の伝説が正史となる、生きた恐怖幻想の世界。',
  'layout.footer.explore': '探索',
  'layout.footer.legal': '法務',
  'layout.footer.accessibility': 'アクセシビリティ',
  'layout.footer.encyclopedia': '百科事典',
  'layout.footer.world': '世界',
  'layout.footer.playVtt': 'プレイ（VTT）',
  'layout.footer.books': 'ルール書&設定書',
  'layout.footer.terms': '利用規約',
  'layout.footer.privacy': 'プライバシーポリシー',
  'layout.footer.canonRelease': '正史投稿同意書',
  'layout.footer.aiPolicy': 'AI方針',
  'layout.footer.cookies': 'クッキー設定',
  'layout.footer.copyright': '© 2026 GameCodex',
}
